import { FieldValues, Control, Path } from 'react-hook-form';

import { SwitchGroupItem } from '../switch-group/switch-group';
import { SwitchGroup } from '../switch-group/switch-group';
import { FormField } from './form';

interface FormSwitchGroupProps<T extends FieldValues> {
  control: Control<T>;
  name: Path<T>;
  className?: string;
  labelClassName?: string;
  switchClassName?: string;
  options: {
    label: string;
    value: string;
  }[];
}

export function FormSwitchGroup<T extends FieldValues>({
  switchClassName,
  labelClassName,
  className,
  options,
  control,
  name,
}: FormSwitchGroupProps<T>) {
  return (
    <FormField
      render={({ field }) => (
        <SwitchGroup onChange={field.onChange} className={className} value={field.value}>
          {options.map((option) => (
            <SwitchGroupItem
              labelClassName={labelClassName}
              className={switchClassName}
              value={option.value}
              name={option.value}
              key={option.value}
              id={option.value}
            >
              {option.label}
            </SwitchGroupItem>
          ))}
        </SwitchGroup>
      )}
      control={control}
      name={name}
    />
  );
}
